interface BusinessInfoStepIndicatorProps {
	currentStepIndex: number;
	totalSteps: number;
}

export default function BusinessInfoStepIndicator({
	currentStepIndex,
	totalSteps,
}: BusinessInfoStepIndicatorProps) {
	return (
		<div className="flex w-full gap-2">
			{Array.from({ length: totalSteps }, (_, i) => (
				<div
					key={i}
					className={`w-full h-1 rounded-full transition-all duration-300 ${
						i < currentStepIndex + 1 ? "bg-primary-blue" : "bg-primary-gray-lightest"
					}`}
				/>
			))}
		</div>
	);
}
